"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasePrice = void 0;
var _react = _interopRequireDefault(require("react"));
var _Price = require("b2b-components/theme/components/Price");
require("./BasePrice.scss");
const BasePrice = _ref => {
  let {
    price,
    unit,
    currency
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Price.Price, {
    currency: currency,
    className: "cds-BasePrice",
    price: price,
    styleType: _Price.PRICE_STYLE_TYPE.secondary,
    size: _Price.PRICE_SIZE.small
  }, /*#__PURE__*/_react.default.createElement(_Price.Tax, null, "\xA0/\xA0", unit));
};
exports.BasePrice = BasePrice;
//# sourceMappingURL=BasePrice.js.map